"use client";
import { memo } from "react";

import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import {
  setFilters,
} from "@/feature/flight/search/state/slices/extract-flight-filter.slice";
import AccordionSection from "./accordion-section";

const data = [
  {
    name: "Refundable",
    status: "true",
  },
  {
    name: "Non Refundable",
    status: "false",
  },
];

const Refutability = memo(() => {
  const dispatch = useAppDispatch();

  const selectOption = useAppSelector((state) => state.extractFlightFilter.selectOption);
  const isResponseEnd = useAppSelector((state) => state.flightSearchStatus.isResponseEnd);
  const selected = selectOption?.refundable;

  const handleChange = (name: string) => {
    const value = name === "true";
    if (selected === value) {
      dispatch(setFilters({ refundable: undefined }));
    } else {
      dispatch(setFilters({ refundable: value }));
    }
  };

  return (
    <AccordionSection value="refund" label="Refundable">
      {data?.map((item, index) => (
        <div key={index} className="flex items-center space-x-2 ">
          <Checkbox
            disabled={!isResponseEnd}
            id={item.name}
            checked={item.status === String(selected)}
            onCheckedChange={() => handleChange(item.status)}
          />
          <Label
            htmlFor={item.name}
            className="font-normal cursor-pointer w-full "
          >
            {item.name}
          </Label>
        </div>
      ))}
    </AccordionSection>
  );
});

Refutability.displayName = "Refutability";

export default Refutability;


